import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { NstiStockTxnLineContainerModel } from '../../../../../../models/aggregates/erp/non-stock-and-trade-in';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class NstiStockTxnLineService extends BaseApiTemplateService<NstiStockTxnLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/txn-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/txn-lines/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'non-stock-trade-in/txn-lines/backoffice-ep';
    this.httpClient = http;
  }

}
